const StafflistIcon = (color:any) => {
  return (
      <svg
        className="ml-7 mr-7"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6792 1.44629C8.7812 1.44629 6.4292 3.79904 6.4292 6.69629C6.4292 9.59429 8.7812 11.9463 11.6792 11.9463C14.5764 11.9463 16.9292 9.59429 16.9292 6.69629C16.9292 3.79904 14.5764 1.44629 11.6792 1.44629ZM11.6792 2.94629C13.7484 2.94629 15.4292 4.62704 15.4292 6.69629C15.4292 8.76629 13.7484 10.4463 11.6792 10.4463C9.6092 10.4463 7.9292 8.76629 7.9292 6.69629C7.9292 4.62704 9.6092 2.94629 11.6792 2.94629Z"
          fill={color?.color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.67919 20.9463H12.0002C12.4142 20.9463 12.7502 21.2823 12.7502 21.6963C12.7502 22.1103 12.4142 22.4463 12.0002 22.4463H1.9292C1.51445 22.4463 1.1792 22.111 1.1792 21.6963C1.1792 21.6963 1.1792 21.0783 1.1792 20.1963C1.1792 16.4688 4.20094 13.4463 7.92919 13.4463H12.0002C12.4142 13.4463 12.7502 13.7823 12.7502 14.1963C12.7502 14.6103 12.4142 14.9463 12.0002 14.9463H7.92919C5.02969 14.9463 2.67919 17.2968 2.67919 20.1963V20.9463Z"
          fill={color?.color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.75 15H21.9877C22.4017 15 22.7377 14.664 22.7377 14.25C22.7377 13.836 22.4017 13.5 21.9877 13.5H15.75C15.336 13.5 15 13.836 15 14.25C15 14.664 15.336 15 15.75 15Z"
          fill={color?.color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.75 18.7441H21.9877C22.4017 18.7441 22.7377 18.4074 22.7377 17.9941C22.7377 17.5801 22.4017 17.2441 21.9877 17.2441H15.75C15.336 17.2441 15 17.5801 15 17.9941C15 18.4074 15.336 18.7441 15.75 18.7441Z"
          fill={color?.color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.75 22.4873H21.9877C22.4017 22.4873 22.7377 22.1513 22.7377 21.7373C22.7377 21.3233 22.4017 20.9873 21.9877 20.9873H15.75C15.336 20.9873 15 21.3233 15 21.7373C15 22.1513 15.336 22.4873 15.75 22.4873Z"
          fill={color?.color}
        />
      </svg>
  );
};
export default StafflistIcon;
